import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';

import { short } from '../../common/formatting/date';
import { API_URL } from '../../../../config/constants';
import { buildPatientProfilePicUrl } from '../../../../lib/util';

const DISPLAYED_SYSTEM_TYPES = {
	video_ended: 'Video Chat Ended',
	video_started: 'Video Chat Started',
	video_declined: 'Video Chat Declined',
};

const ChatBubble = ({ message, showFrom = true, showTimestamp = true }) => {
	const { provider, patient } = message;
	let status = DISPLAYED_SYSTEM_TYPES[message.text];
	let imgUrl;

	const sentDttm = short(message.sent_dttm, false, "MMM do 'at' p");

	let participantType, action;
	if (message.participant_type) {
		[participantType, action] = message.participant_type.split(' ');
		if ('image' === action) {
			imgUrl = `${API_URL}/evisit_images/${message.evisitId}/download/${message.text}`;
		}
	}

	if (!status && ['system'].includes(message.participant_type)) {
		status = 'Care Convene';
	}

	let text;
	if (!DISPLAYED_SYSTEM_TYPES[text]) {
		text = message.text;
	}

	return (
		<li
			className={cn({
				self: ['provider', 'system'].includes(participantType),
				other: !['provider', 'system'].includes(participantType),
				'no-from': !showFrom,
			})}
		>
			{participantType === 'patient' && patient && showFrom && (
				<img
					src={buildPatientProfilePicUrl(patient)}
					className="avatar img-circle"
				/>
			)}
			<div className={cn('message', { 'no-avatar': !showFrom })}>
				{showFrom && ['patient', 'provider'].includes(participantType) && (
					<React.Fragment>
						<div className="name">
							{participantType === 'patient' && patient && patient.name_first}
							{participantType === 'provider' &&
								provider &&
								`${provider.name_first} ${provider.name_last}${
									provider.credentials ? `, ${provider.credentials}` : ''
								}`}
						</div>
					</React.Fragment>
				)}
				<div className="content">
					{'image' === action && (
						<p>
							<img src={imgUrl} />
						</p>
					)}
					{!action && !DISPLAYED_SYSTEM_TYPES[text] && (
						<p>{isEmpty(text) ? '<NO CONTENT>' : text}</p>
					)}
				</div>
				{showTimestamp && (
					<div className="timestamp">
						<small>
							{!isEmpty(status) && `${status} • `}
							{sentDttm}
						</small>
					</div>
				)}
			</div>
		</li>
	);
};

ChatBubble.propTypes = {
	message: PropTypes.object.isRequired,
	showFrom: PropTypes.bool,
	showTimestamp: PropTypes.bool,
};

export default ChatBubble;
